/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import ChunkLODNode from "App/utils/globe/chunk_lod/tree/chunk_lod_node";
import PatchManager from "App/utils/globe/chunk_lod/patch_manager";
import ProgressiveDataHandler from "App/utils/globe/chunk_lod/data/progressive_data_handler";
import {vec3} from "gl-matrix";
import IAddress from "App/utils/globe/chunk_lod/adress";
import BoundingBox from "App/utils/bounding_box";

export default
class ProgressiveChunkLODNode extends ChunkLODNode {
    constructor(aPatch: PatchManager, aParent: ProgressiveChunkLODNode, aAddress: IAddress) {
        super(aPatch, aParent, aAddress);
    }

    public setData(aData: any) {
        this._data = new ProgressiveDataHandler(this);
        this._data.fill(aData, this._address);

        // tweak bbox top and bottom to what is stored in metadata
        this._bbox = new BoundingBox(this._data.getMetadata().bbox.min, this._data.getMetadata().bbox.max);

        this._center = vec3.clone(this._bbox.getCenter());
    }

    public createChild(aIndex: number) {
        let address = this._address.create({
            base: this._address.base,
            origin: this._address.origin,
            patchInfo: this._address.patchInfo,
            level: this._address.level + 1,
            layer: this._address.layer * 2 + Math.floor((aIndex / 4) + 0.1),
            row: this._address.row * 2 + Math.floor(((aIndex % 4) / 2) + 0.1), // % 4 is to handle octree
            col: this._address.col * 2 + (aIndex % 2),
            translationOffset: this._address.translationOffset
        });

        this._children[aIndex] = new ProgressiveChunkLODNode(this._patch, this, address);

        return this._children[aIndex];
    }

    public getAttributes(aAddress: IAddress, aAttributes: any) {
        let data;

        if (this.getParent()) {
            this.getParent().getAttributes(aAddress, aAttributes);
        }

        data = this._data.getAttributes(aAddress);

        aAttributes.positions.set(new Uint8Array(data.positions), aAttributes.positionsPos);
        aAttributes.positionsPos += data.positions.byteLength;

        aAttributes.normals.set(new Uint8Array(data.normals), aAttributes.normalsPos);
        aAttributes.normalsPos += data.normals.byteLength;

        aAttributes.texcoords.set(new Uint8Array(data.texcoords), aAttributes.texcoordsPos);
        aAttributes.texcoordsPos += data.texcoords.byteLength;

        aAttributes.layers.set(new Uint8Array(data.layers), aAttributes.layersPos);
        aAttributes.layersPos += data.layers.byteLength;

        aAttributes.surfacestyles.set(new Uint8Array(data.surfacestyles), aAttributes.surfacestylesPos);
        aAttributes.surfacestylesPos += data.surfacestyles.byteLength;
    }
}
